<div class="field-dialog">
  <mat-toolbar class="field-dialog__header" fxLayout="row" fxLayoutAlign="space-between center">
    <h2 class="field-dialog__header__title" *ngIf="!data.locationSector?.id">Adicionar setor</h2>
    <h2 class="field-dialog__header__title" *ngIf="data.locationSector?.id">{{ data.locationSector.name }}</h2>
    <button class="field-dialog__header__close" mat-icon-button mat-dialog-close>
      <mat-icon>close</mat-icon>
    </button>
  </mat-toolbar>

  <mat-tab-group class="field-dialog__content">
    <mat-tab>
      <ng-template mat-tab-label>
        <span>{{ 'LOCATION_SECTOR_DIALOG.TAB.GENERAL' | translate }}</span>
      </ng-template>
      <ng-template matTabContent>
        <tab-general [isViewMode]="isViewMode" [locationSectorForm]="locationSectorForm"></tab-general>
      </ng-template>
    </mat-tab>

    <mat-tab
      [label]="'LOCATION_SECTOR_DIALOG.TAB.MAINTENANCES.LABEL' | translate"
      [disabled]="!data.locationSector?.id"
    >
      <ng-template matTabContent>
        <tab-maintenances [locationSector]="data.locationSector"></tab-maintenances>
      </ng-template>
    </mat-tab>
  </mat-tab-group>

  <div *ngIf="!isViewMode" class="field-dialog__footer" fxLayout="row" fxLayoutAlign="space-between center">
    <button
      class="field-background"
      data-cy="dialog-locations-save-button"
      color="primary"
      mat-raised-button
      [disabled]="!locationSectorForm?.valid || isLoading"
      (click)="saveLocationSector()"
    >
      {{ 'LOCATION_SECTOR_DIALOG.BUTTON.SAVE' | translate }}
    </button>
  </div>
</div>
